export const BANK_ACCOUNT_LIST_REQUEST = 'BANK_ACCOUNT_LIST_REQUEST';
export const BANK_ACCOUNT_LIST_REQUEST_SUCCESS = 'BANK_ACCOUNT_LIST__REQUEST_SUCCESS';
export const BANK_ACCOUNT_LIST_REQUEST_FAILURE = 'BANK_ACCOUNT_LIST_REQUEST_FAILURE';
export const CLEAR_BANK_ACCOUNT_LIST_DATA = 'CLEAR_BANK_ACCOUNT_LIST_DATA';
